const disableHtmlScroll = {
    methods: {
        opened: function () {
            document.documentElement.classList.add('modal-open')
        },
        closed: function () {
            document.documentElement.classList.remove('modal-open')
        },
    },
}

export default disableHtmlScroll;

